import React, { useMemo } from 'react'
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd'
import s from './styles/ColumnsManager.module.scss'
import { ReactComponent as SearchIcon } from 'assets/icons/search_list.svg'
import { useColumnsManager } from './hooks/useColumnsManager'

const HIDDEN_COLUMN_IDS = ['select', 'student']

export default function ColumnsManager({
	items = [],
	onReorder,
	onDeactivate,
}) {
	const { isOpen, toggleOpen, onDragEnd } = useColumnsManager({ onReorder })

	const visibleItems = useMemo(
		() => (items || []).filter(c => c && !HIDDEN_COLUMN_IDS.includes(c.id)),
		[items]
	)

	return (
		<div className={s.wrap}>
			<button
				type="button"
				className={s.head}
				onClick={toggleOpen}
				aria-expanded={isOpen}
			>
				<div className={s.title}>
					<div className={s.title__icon}>
						<SearchIcon />
					</div>
					<span className={s.title__text}>Manage Columns</span>
				</div>

				<div className={`${s.arrow} ${isOpen ? s.open : ''}`} />
			</button>

			<div className={`${s.collapse} ${isOpen ? s.open : ''}`}>
				<div className={s.content}>
					<span className={s.subtitle}>Drag to manage</span>

					<DragDropContext onDragEnd={onDragEnd}>
						<Droppable droppableId="columns">
							{provided => (
								<div
									ref={provided.innerRef}
									{...provided.droppableProps}
									className={s.list}
								>
									{visibleItems.map((col, index) => (
										<Draggable
											key={String(col.id)}
											draggableId={String(col.id)}
											index={index}
										>
											{prov => (
												<div
													ref={prov.innerRef}
													{...prov.draggableProps}
													className={s.item}
												>
													<div className={s.item__inner}>
														<div
															className={s.item__drag}
															{...prov.dragHandleProps}
															aria-hidden="true"
														>
															⋮⋮
														</div>

														<div className={s.item__info}>
															<span className={s.item__title}>{col.title}</span>
															<span className={s.item__subtitle}>
																{col.subtitle}
															</span>
														</div>
													</div>

													<button
														type="button"
														className={s.item__btn}
														onClick={e => {
															e.stopPropagation()
															onDeactivate?.(col.id)
														}}
														aria-label="Deactivate column"
													>
														<span>-</span>
													</button>
												</div>
											)}
										</Draggable>
									))}

									{provided.placeholder}
								</div>
							)}
						</Droppable>
					</DragDropContext>
				</div>
			</div>
		</div>
	)
}
